'use client';

import React, { type AnchorHTMLAttributes, type FC } from 'react';

import { combineLinkWithParameters } from '@/utils/combine-link-with-parameters';

interface ParamLinkProps extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href' | `on${string}`> {
    to: string;
}

export const ParamLink: FC<ParamLinkProps> = ({ to, ...props }) => {
    return (
        <a
            {...props}
            href={to}
            onClick={(event) => {
                event.preventDefault();

                const href = combineLinkWithParameters(to);

                if (event.metaKey || event.ctrlKey || event.shiftKey) {
                    window.open(href, '_blank');

                    return;
                }

                window.location.href = href;
            }}
            onAuxClick={(event) => {
                if (event.button === 1) {
                    event.preventDefault();

                    window.open(combineLinkWithParameters(to), '_blank');
                }
            }}
        />
    );
};
